/**
 * The words for a chart's form (plan §7, standards §12), one set for every
 * surface that names one: the screen reader's description of a drawn chart
 * (components/charts/chartAria.js) and the Reports list's rows. Outside the
 * charts chunk, so a page that lists charts without drawing them reads them
 * too.
 */
export const CHART_FORM_WORDS = Object.freeze({
	number: 'Number',
	progress: 'Progress meter',
	bar: 'Bar chart',
	line: 'Line chart',
	area: 'Area chart',
	donut: 'Donut chart',
	heatmap: 'Heat map',
	calendar: 'Calendar',
	table: 'Table',
});

/** The form a saved chart is drawn as ("Bar chart"), or "Chart" for a form this build does not know. */
export function chartFormWord(form) {
	return typeof form === 'string' && Object.prototype.hasOwnProperty.call(CHART_FORM_WORDS, form) ? CHART_FORM_WORDS[form] : 'Chart';
}
